
import { z } from "zod";

export const WorkOrderConcessionTypeValues = ["TRAVEL_ADDER", "JOB_SIZE_ADDER"] as const;
export const WorkOrderConcessionTypeSchema = z.enum(WorkOrderConcessionTypeValues);
export const WorkOrderConcessionType = WorkOrderConcessionTypeSchema.enum;
export type WorkOrderConcessionType = (typeof WorkOrderConcessionTypeValues)[number];
export const WorkOrderConcessionTypeDisplayNames = { "TRAVEL_ADDER": "Travel adder",
"JOB_SIZE_ADDER": "Job size adder", } satisfies Record<WorkOrderConcessionType, string>;
